export default "__VITE_PUBLIC_ASSET__3ff31746__"